import {SendMessageAction} from '../../node.js';
import {outgoing} from '../../common/messages.js';
import {globalDomainUri} from './constants.js';
import {DomainInfo, DomainUri} from '../../state/types/domain-registry.js';
import {RemoteJoin, Welcome, WelcomeOptions} from './types/messages.js';
import {Identity, LocalAddress, Restrictions, Source} from '../../state/types/common.js';
import {Options} from '../../state/types/state.js';

export function welcome(recipient: LocalAddress,
                        requestId: string,
                        peerId: string,
                        availableDomains: Array<DomainInfo>,
                        resolvedIdentity: Record<string, unknown>,
                        options?: WelcomeOptions): SendMessageAction<'welcome'> {
    const message: Welcome = {
        domain: globalDomainUri,
        type: 'welcome',
        request_id: requestId,
        peer_id: peerId,
        available_domains: availableDomains,
        resolved_identity: resolvedIdentity
    };
    if (options) {
        message.options = options;
    }
    return outgoing(recipient, message);
}

export function authenticationRequest(domainUri: DomainUri, recipient: LocalAddress, requestId: string, peerId: string | undefined, details: unknown): SendMessageAction<'authentication-request'> {
    const message: {domain, type, request_id, authentication, peer_id?} =
        {domain: domainUri, type: 'authentication-request', request_id: requestId, authentication: details};
    if (peerId) {
        message.peer_id = peerId;
    }
    return outgoing(recipient, message);
}


export function join(requestId: string| undefined, peerId: string, restrictions: Restrictions, domainUri: DomainUri, peerIdentity: Identity, options?: Options): RemoteJoin {
    const message: RemoteJoin = {
        domain: globalDomainUri,
        type: 'join',
        request_id: requestId as string,
        peer_id: peerId,
        destination: domainUri,
        identity: peerIdentity
    }
    if (restrictions) {
        message.restrictions = restrictions;
    }
    if (options) {
        message.options = options;
    }
    return message;
}

export function ping(recipient: Source): SendMessageAction<'ping'> {
    return outgoing(recipient, {type: 'ping'})
}
